import { createSelector } from "@ngrx/store";
import { DrawingAttachmentKind } from "src/api-service";
import { selectQuoteState } from "../quote.selectors";
import { selectVersion } from "../version/version.selectors";

// ============================================================================
// DRAWING
// ============================================================================

export const selectDrawing = createSelector(
    selectQuoteState,
    state => state.drawing
);

export const selectDrawingAttachments = createSelector(
    selectDrawing,
    drawing => drawing?.attachments ?? []
);

export const selectFloorPlanAttachments = createSelector(
    selectDrawingAttachments,
    attachments => attachments.filter(a => a.kind === DrawingAttachmentKind.FloorPlan)
);

export const selectImageAndOtherAttachments = createSelector(
    selectDrawingAttachments,
    attachments => attachments.filter(a => a.kind !== DrawingAttachmentKind.FloorPlan)
);

// ============================================================================
// UPLOADS
// ============================================================================

export const selectDrawingUploads = createSelector(
    selectQuoteState,
    state => state.drawingUploads ?? []
);

export const selectUploadingFloorPlans = createSelector(
    selectDrawingUploads,
    uploads => uploads.filter(u => u.kind === DrawingAttachmentKind.FloorPlan)
);

export const selectUploadingImages = createSelector(
    selectDrawingUploads,
    uploads => uploads.filter(u => u.kind !== DrawingAttachmentKind.FloorPlan)
);

export const selectIsUploading = createSelector(
    selectDrawingUploads,
    uploads => uploads.length > 0
);

// ============================================================================
// DRAWING DETAILS
// ============================================================================

export const selectDrawingRoomComments = createSelector(
    selectVersion,
    version => (version?.itemGroups ?? []).map(g => ({
        itemGroupId: g.id,
        name: g.name ?? '',
        internalComment: g.internalComment ?? '',
    }))
);

export const selectDrawer = createSelector(
    selectDrawing,
    drawing => drawing?.drawer
);

export const selectDrawingEstimatedCompletion = createSelector(
    selectDrawing,
    drawing => drawing?.estimatedCompletion
);

export const selectDrawingSharepointUrl = createSelector(
    selectDrawing,
    drawing => drawing?.sharepointUrl
);

// ============================================================================
// SEND FOR DRAWING VALIDATION
// ============================================================================

export const selectCanSendForDrawing = createSelector(
    selectDrawing,
    drawing => (drawing?.attachments ?? []).some(a => a.kind === DrawingAttachmentKind.FloorPlan)
);

export const selectSendForDrawingBlockers = createSelector(
    selectCanSendForDrawing,
    canSend => canSend ? [] : ["QUOTE.DRAWING.BLOCKER_NO_FLOORPLAN"]
);
